var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Main',{ref:"main",attrs:{"disabled":_vm.disabled,"amzFirstDemandCode":_vm.amzFirstDemandCode},on:{"close":_vm.close,"reset":function () { return _vm.$emit('reset'); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }